import { DELIVERY_TYPE_NORMAL } from "../models/Delivery";

export const NEW_DELIVERY_TYPE_DOCUMENT = "DOCUMENT";
export const NEW_DELIVERY_TYPE_POSTBOX = "POSTBOX";

export const NEW_DELIERY_TYPES = [
  {
    text: "서류",
    code: NEW_DELIVERY_TYPE_DOCUMENT,
  },
  {
    text: "포스트박스",
    code: NEW_DELIVERY_TYPE_POSTBOX,
  },
];

export const COMPLETED_LOCATION_DOOR = "COMPLETED_LOCATION_DOOR";
export const COMPLETED_LOCATION_POSTBOX = "COMPLETED_LOCATION_POSTBOX";
export const COMPLETED_LOCATION_SECURITY = "COMPLETED_LOCATION_SECURITY";
export const COMPLETED_LOCATION_RECEIVER = "COMPLETED_LOCATION_RECEIVER";
export const COMPLETED_LOCATION_FAMILY = "COMPLETED_LOCATION_FAMILY";
export const COMPLETED_LOCATION_COWORKER = "COMPLETED_LOCATION_COWORKER";
export const COMPLETED_LOCATION_NEIGHBOR = "COMPLETED_LOCATION_NEIGHBOR";
export const COMPLETED_LOCATION_DEFAULT = "COMPLETED_LOCATION_DEFAULT";

export const COMPLETED_LOCATIONS = [
  {
    text: "문앞",
    code: COMPLETED_LOCATION_DOOR,
  },
  {
    text: "택배함(우편함)",
    code: COMPLETED_LOCATION_POSTBOX,
  },
  {
    text: "경비실",
    code: COMPLETED_LOCATION_SECURITY,
  },
  {
    text: "본인 수령",
    code: COMPLETED_LOCATION_RECEIVER,
  },
  {
    text: "가족 수령",
    code: COMPLETED_LOCATION_FAMILY,
  },
  {
    text: "직장동료 수령",
    code: COMPLETED_LOCATION_COWORKER,
  },
  {
    text: "이웃 수령",
    code: COMPLETED_LOCATION_NEIGHBOR,
    withText: false,
  },
  {
    text: "기본 보관장소",
    code: COMPLETED_LOCATION_DEFAULT,
    withText: false,
  },
];

export const CAPTURE_METHOD = {
  SIGNATURE: "signature",
  TAKE_PICTURE: "takePicture",
  SELECT_PICTURE: "selectPicture",
};

/**
 * 배송완료 SMS 발송 여부 판단 (원본 shouldSendSms 로직)
 * @param {object} delivery - Delivery 모델 인스턴스
 * @param {string} completedLocationCode - 완료위치 코드(COMPLETED_LOCATION_*)
 * @returns {boolean}
 */
export const shouldSendSms = (delivery, completedLocationCode) => {
  if (!delivery) return false;

  const receiverMobile = delivery.receiverSmsMobile || delivery.receiverMobile;

  // 기본 조건 체크 (NativeModules.DirectSms는 웹뷰 미해당이라 제외)
  if (!receiverMobile || delivery.type !== DELIVERY_TYPE_NORMAL) {
    return false;
  }

  // 유효한 전화번호 체크
  if (!receiverMobile.startsWith("01")) {
    return false;
  }

  // 1. 고가품인 경우 무조건 발송
  if (delivery.spotLuxuryAvailable) {
    return true;
  }

  // 2. 시간제한이 있는 경우 무조건 발송
  if (delivery.isLimitedHours) {
    return true;
  }

  // 3. 알림문자 활성 && 완료위치가 문앞/본인수령이 아니면 발송
  if (delivery.spot?.deliveredSmsActive) {
    return (
      completedLocationCode !== COMPLETED_LOCATION_DOOR &&
      completedLocationCode !== COMPLETED_LOCATION_RECEIVER
    );
  }

  return false;
};
